module.exports = __webpack_public_path__ + "static/img/loading.69a70c73.gif";